import { render, staticRenderFns } from "./examineeDetail.vue?vue&type=template&id=162c89cf&scoped=true&"
import script from "./examineeDetail.vue?vue&type=script&lang=js&"
export * from "./examineeDetail.vue?vue&type=script&lang=js&"
import style0 from "./examineeDetail.vue?vue&type=style&index=0&id=162c89cf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162c89cf",
  null
  
)

export default component.exports